<ion-app>
  @if (ready) {
    @if (isDesktop) {
      <app-desktop-header></app-desktop-header>
    }
    <ion-router-outlet [animated]="!isDesktop"></ion-router-outlet>
  } @else {
    <app-loader
      [full]="true"
      [loading]="true"
    ></app-loader>
  }
</ion-app>
